export const OVERLAY_DISPOSE_TIMEOUT = 1000;
